module.exports = __webpack_public_path__ + "static/media/icon_split_payment.08aff4e5.png";